"use client";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid } from "swiper/modules";
import pauseAutoplayOffscreen from "@/utils/pauseAutoplayOffscreen";
// import "swiper/css";
// import "swiper/css/grid";

import Title from "../Title";



const LogoCard = ({ logo }) => (
  <div
    className="w-24 h-24 sm:w-28 sm:h-28 md:w-35 md:h-35 lg:w-47 lg:h-47 mx-auto
    rounded-full flex items-center justify-center
    transition-transform duration-300 hover:scale-105
    p-[1px] bg-gradient-to-b from-[rgba(255,242,128,1)] to-[rgba(128,210,254,1)]"
  >
    <div className="w-full h-full flex items-center justify-center rounded-full overflow-hidden bg-white">
      <div className="relative rounded-full overflow-hidden p-3 md:p-6 w-full h-full">
        <div className="relative w-full h-full bg-white overflow-hidden flex items-center justify-center">
          <Image
            src={logo.src}
            alt={logo.alt}
            width={180}
            height={180}
            className="object-contain"
          />
        </div>
      </div>
    </div>
  </div>
);

const Logos = ({ data, loading }) => {
  // Media URL helper
  const getMediaUrl = (media) => {
    const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL || "http://localhost:1337";
    const url = media?.url || media?.data?.attributes?.url || media?.data?.url;
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${baseUrl}${url}`;
  };

  // Rich Text helper for Strapi Blocks
  const renderRichText = (blocks) => {
    if (typeof blocks === 'string') return blocks;
    if (Array.isArray(blocks)) {
      return blocks.map(block => {
        if (block.type === 'paragraph') {
          return block.children.map(child => child.text).join('');
        }
        return '';
      }).join('\n');
    }
    return '';
  };

  const logosArray = data?.Logos?.data || data?.Logos || [];

  const dynamicLogos = logosArray
    .map((logo) => {
      const image = logo?.attributes || logo;
      const src = getMediaUrl(image);
      const alt =
        logo?.attributes?.alternativeText ||
        logo?.attributes?.name ||
        logo?.alternativeText ||
        logo?.name ||
        "Recognition Logo";

      if (!src) return null;
      return { src, alt };
    })
    .filter(Boolean);

  const displayLogos = dynamicLogos;
  const swiperKey = `${displayLogos.length}-${displayLogos.length > 6 ? "loop" : "noloop"}`;

  if (loading && !data) {
    return (
      <div className="w-full h-48 bg-gray-50 animate-pulse flex items-center justify-center">
        <p className="text-gray-400">Loading Recognitions...</p>
      </div>
    );
  }

  if (!displayLogos.length) {
    return null;
  }

  return (
    <section className="w-full top_bottom_space bg-cover bg-center bg-no-repeat px-2">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="heading_space_bottom">
          <Title
            heading={data?.Title || "Recognised by National and Regulatory Bodies"}
            subText={renderRichText(data?.Description) || "MSU stands among India's leading institutions, recognised by UGC and NCVET. We offer industry-focused, NEP 2020-aligned higher education that prepares learners for practical success."}
            color="text-black"
            subTextColor="text-black/70"
            align="text-left"
          />
        </div>

        {/* Mobile Slider - 2 rows with auto-sliding */}
        <div className="block md:hidden">
          <Swiper
            onSwiper={pauseAutoplayOffscreen}
            key={swiperKey}
            modules={[Autoplay, Grid]}
            spaceBetween={16}
            slidesPerView={3}
            grid={{
              rows: 2,
              fill: "row",
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={displayLogos.length > 6}
            observer={true}
            observeParents={true}
            className="logo-swiper"
          >
            {displayLogos.map((logo, index) => (
              <SwiperSlide key={logo.src || index} className="!h-auto py-2">
                <LogoCard logo={logo} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-4 lg:grid-cols-6 justify-between gap-5">
          {displayLogos.map((logo, index) => (
            <LogoCard key={index} logo={logo} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;
